import styled from "styled-components";

export const ButtonContainer = styled.div`
  border: 2px solid #2980b9;
  width: 70%;
  display: flex;
  margin-top: 3rem;
  flex-direction: row;
  justify-content: center;
  font-family: Poppins;
  border-radius: 3rem;
  color: #ffffff;
  font-size: 22px;
  text-align: center;
  padding: 1.1rem 1rem;
  cursor: pointer;
  &:hover {
    background: #3498db;
  }
  @media (max-width: 768px) {
    width: 90%;
  }
`;
